export type UtmSource = 'whatsapp' | 'facebook' | 'instagram' | 'google';

export const UTM_SOURCES: readonly UtmSource[] = [
  'whatsapp',
  'facebook',
  'instagram',
  'google',
] as const;
